const initializeMpmGuide = (root) => {
  if (!root || root.dataset.mpmMotionInitialized === 'true') return;

  root.dataset.mpmMotionInitialized = 'true';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = root.querySelectorAll('.mpm-content > section, .mpm-panel, .mpm-final');
  const staggerGroups = root.querySelectorAll(
    '.mpm-audience__list, .mpm-receive__stats, .mpm-chapters, .mpm-preview__track, .mpm-review-grid, .mpm-faq-grid'
  );

  revealItems.forEach((item) => item.setAttribute('data-mpm-reveal', ''));

  staggerGroups.forEach((group) => {
    group.setAttribute('data-mpm-stagger', '');
    Array.from(group.children).forEach((child, index) => {
      child.style.setProperty('--mpm-delay', `${Math.min(index * 55, 330)}ms`);
    });
  });

  root.classList.add('mpm-motion-ready');

  const revealAll = () => {
    revealItems.forEach((item) => item.classList.add('is-visible'));
    staggerGroups.forEach((group) => group.classList.add('is-visible'));
  };

  if (prefersReducedMotion || !('IntersectionObserver' in window)) {
    revealAll();
  } else {
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    revealItems.forEach((item) => revealObserver.observe(item));
    staggerGroups.forEach((group) => revealObserver.observe(group));
  }

};

const initializeAllMpmGuides = () => {
  document.querySelectorAll('.mpm-product').forEach(initializeMpmGuide);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAllMpmGuides, { once: true });
} else {
  initializeAllMpmGuides();
}

document.addEventListener('shopify:section:load', (event) => {
  initializeMpmGuide(event.target.querySelector('.mpm-product'));
});
